import { useEffect, useState } from "react";

import { isValidNumericParam } from "@/shared/utils/common.utils";
import { TestHttpService } from "@/shared/services/tests/test-http.service";

import { IClientTest } from "../types/test.interface";

export function useAllClientTestsHook(
  clientId: number,
  { standaloneOnly = false, assessmentId }: { standaloneOnly?: boolean; assessmentId?: number } = {},
) {
  const [tests, setAllTests] = useState<IClientTest[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchTests = async () => {
      try {
        setIsLoading(true);

        const tests: IClientTest[] = await TestHttpService.getAllClientTests(clientId, {
          standaloneOnly,
          assessmentId,
        });
        if (tests.length !== 0) {
          const sortedTests: IClientTest[] = tests.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
          );
          setAllTests(sortedTests);
        }

        setIsLoading(false);
      } catch (e: any) {
        setIsLoading(false);
      }
    };
    if (isValidNumericParam(clientId)) {
      fetchTests();
    }
  }, [clientId, standaloneOnly, assessmentId]);

  return { tests, isLoading };
}
